export default __webpack_public_path__ + "img/8dbff80e41ada545681f68e492c225fa.svg";